import { GameVer, useT, useTurl } from "~/util/Lang";
import css from "./PaperDoll.module.css";
import { Icon32 } from "../ui/Icon";
import { EntityTooltip } from '../site/Tooltip';
import { Link } from 'react-router';

type Item = { id: number; itemName: string; icon: string; };

type Data = {
  sUnderwear?: Item;
  sHead?: Item;
  sBack?: Item;
  sRhand?: Item;
  sChest?: Item;
  sLhand?: Item;
  sGloves?: Item;
  sLegs?: Item;
  sFeet?: Item;
  sHair?: Item;
  sNeck?: Item;
  sEar1?: Item;
  sEar2?: Item;
  sFinger1?: Item;
  sFinger2?: Item;
};

export function PaperDoll(params: { gver: GameVer, data: Data; }) {
  switch (params.gver) {
    default:
      return <DollC5 data={params.data} />;
  }
}

function DollC5(params: { data: Data; }) {
  const { data } = params;
  return (
    <div className={css.rootC4}>
      <div className={css.title}>Paper Doll</div>
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        <div className={css.grid33}>
          <Slot item={data.sUnderwear} type='underwear' />
          <Slot item={data.sHead} type='head' />
          <Slot item={data.sBack} type='back' />
          <Slot item={data.sRhand} type='rhand' />
          <Slot item={data.sChest} type='chest' />
          <Slot item={data.sLhand} type='lhand' />
          <Slot item={data.sGloves} type='gloves' />
          <Slot item={data.sLegs} type='legs' />
          <Slot item={data.sFeet} type='feet' />
        </div>
        <div className={css.grid23}>
          <Slot item={data.sHair} type='hair' />
          <Slot item={data.sNeck} type='neck' />
          <Slot item={data.sEar1} type='ear' />
          <Slot item={data.sEar2} type='ear' />
          <Slot item={data.sFinger1} type='finger' />
          <Slot item={data.sFinger2} type='finger' />
        </div>
        <div className={css.grid13}>
          <div className={css.slot}></div>
          <div className={css.slot}></div>
          <div className={css.slot}></div>
        </div>
      </div>
    </div >
  );
}

type SlotType = "underwear" | "head" | "back" | "rhand" | "chest" | "lhand" | "gloves" | "legs" | "feet" | "hair" | "neck" | "ear" | "finger";

function Slot(params: { item?: Item; type: SlotType; }) {
  const { item, type } = params;
  const turl = useTurl();
  return item ?
    <div>
      <EntityTooltip what={{ t: "item", uname: item.itemName }}>
        {({ setReference, getReferenceProps }) => (
          <Link
            ref={setReference}
            to={turl(`/items/${item.itemName}`)}
            {...getReferenceProps({})}
          >
            <Icon32 icon={item.icon} alt={item.itemName} />
          </Link>
        )}
      </EntityTooltip>
    </div> :
    <SlotPlaceholder type={type} />;
}

function SlotPlaceholder(params: { type: SlotType; }) {
  let element: { icon: string, alt: string; };
  switch (params.type) {
    case "underwear":
      element = { icon: "slot_underwear", alt: "Underwear slot" };
      break;
    case "head":
      element = { icon: "slot_head", alt: "Head slot" };
      break;
    case "back":
      element = { icon: "slot_back", alt: "Back slot" };
      break;
    case "rhand":
      element = { icon: "slot_rhand", alt: "Weapon slot" };
      break;
    case "chest":
      element = { icon: "slot_chest", alt: "Body slot" };
      break;
    case "lhand":
      element = { icon: "slot_lhand", alt: "Shield slot" };
      break;
    case "gloves":
      element = { icon: "slot_gloves", alt: "Gloves slot" };
      break;
    case "legs":
      element = { icon: "slot_legs", alt: "Lower Body slot" };
      break;
    case "feet":
      element = { icon: "slot_feet", alt: "slot_feet" };
      break;
    case "hair":
      element = { icon: "slot_hair", alt: "Hair slot" };
      break;
    case "neck":
      element = { icon: "slot_neck", alt: "Neck slot" };
      break;
    case "ear":
      element = { icon: "slot_ear", alt: "Ear slot" };
      break;
    case "finger":
      element = { icon: "slot_finger", alt: "Finger slot" };
      break;
    default:
      element = { icon: "undefined", alt: "undefined" };
  }
  return <div className={css.slotWrap}>
    <div className={css.slot}>
      <Icon32 {...element} />
    </div>
  </div>;
}
